import { render, staticRenderFns } from "./DeliveryPrint.vue?vue&type=template&id=016a796e&scoped=true&"
import script from "./DeliveryPrint.vue?vue&type=script&lang=js&"
export * from "./DeliveryPrint.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPrint.vue?vue&type=style&index=0&id=016a796e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a796e",
  null
  
)

export default component.exports